import { DEVICE_NAME } from './vice-constants';

export const itemsInArrayCount = (inputArray = []) => {
  if (!inputArray.length) return {};
  const inputCounts = {};
  for (const num of inputArray) {
    inputCounts[num] = inputCounts[num] ? inputCounts[num] + 1 : 1;
  }
  return inputCounts;
};

export const generateCameraData = (
  name,
  cameraDeviceId = 'default',
  isActive = false,
  camLabel = null,
) => ({
  name,
  camLabel,
  uniqueId: name.toLowerCase().replace(/ /g, '_'),
  cameraDeviceId,
  micDeviceId: 'default',
  localTracks: [],
  deviceSelection: {
    [DEVICE_NAME.MICROPHONE]: { active: false, choice: null },
    [DEVICE_NAME.SPEAKERS]: { active: false, choice: null },
    [DEVICE_NAME.CAMERA]: { active: false, choice: null },
  },
  jitsiRoom: null,
  audioRef: null,
  videoRef: null,
  image: `https://ui-avatars.com/api/?name=${name}&bold=true&background=FFFFFF&color=24b8a6&format=PNG`,
  isMicrophoneOn: false,
  isCameraOn: false,
  isActive,
});

export const getBrowserNameAndVersion = () => {
  const userAgent = navigator.userAgent;
  let browserName = 'Unknown';

  if (userAgent.indexOf('Firefox') !== -1 || userAgent.indexOf('FxiOS') !== -1) {
    browserName = 'Mozilla Firefox';
  } else if (userAgent.indexOf('Opera') !== -1 || userAgent.indexOf('OPR') !== -1) {
    browserName = 'Opera';
  } else if (userAgent.indexOf('Edge') !== -1 || userAgent.indexOf('Edg') !== -1) {
    browserName = 'Microsoft Edge';
  } else if (userAgent.indexOf('Chrome') !== -1 || userAgent.indexOf('CriOS') !== -1) {
    browserName = 'Google Chrome';
  } else if (userAgent.indexOf('Safari') !== -1) {
    browserName = 'Apple Safari';
  } else if (userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1) {
    browserName = 'Internet Explorer';
  }
  return browserName;
};

export const getOSInfo = () => {
  const userAgent = window.navigator.userAgent;
  let osName = 'Unknown OS';

  if (userAgent.indexOf('Win') !== -1) {
    osName = 'Windows';
  } else if (userAgent.indexOf('Mac') !== -1) {
    osName = 'MacOS';
  } else if (userAgent.indexOf('Linux') !== -1) {
    osName = 'Linux';
  } else if (userAgent.indexOf('X11') !== -1) {
    osName = 'UNIX';
  } else if (userAgent.indexOf('Android') !== -1) {
    osName = 'Android';
  } else if (userAgent.indexOf('like Mac') !== -1) {
    osName = 'iOS';
  }
  return osName;
};

export const isMobileDevice = () => {
  const userAgent = navigator.userAgent;
  return userAgent.includes('Mobile');
};

export const getScreenResolution = () => {
  const width = Math.trunc(window.screen.width * window.devicePixelRatio);
  const height = Math.trunc(window.screen.height * window.devicePixelRatio);

  return `${width}x${height}`;
};
export const capitalizeFirstLetter = (str) =>
  String(str).charAt(0).toUpperCase() + String(str).slice(1);
